import * as React from "react";

import {
  Box,
  Slide,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Button,
} from "@mui/material";
import { capitalize } from "lodash";
import { Danger } from "react-iconly";
import { checkImgExtension } from "../../constants/function";
import { useTranslation } from "react-i18next";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ErrorPopup({ open, handleClose, error }) {
  const { t } = useTranslation("common");
  const [errors, setErrors] = React.useState({});
  const getWords = (words) => {
    const word = words.replace(/([a-z0-9])([A-Z])/g, "$1 $2");
    return word;
  };

  React.useEffect(() => {
    setErrors({ ...error });
    return () => {
      setErrors({});
    };
  }, [error]);
  return (
    <Box color="default">
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleClose()}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: "white",
            boxShadow: "none",
            color: "#000000",
            borderRadius: "4px",
            padding: 0,
            width: "343px",
            height: "auto",
          },
        }}
      >
        <DialogContent>
          <Danger
            style={{
              display: "flex",
              margin: "auto",
            }}
            width={"100px"}
            height={"100px"}
            set="light"
            primaryColor="#FFEE20"
          />
          {errors &&
            Object.keys(errors).map((key, index) => (
              <DialogContentText
                sx={{
                  display: "flex",
                  gap: "5px",
                  flexDirection: "column",
                }}
                key={index}
                color="secondary"
              >
                {key !== "GIF" &&
                key !== "ISRCCode" &&
                key !== "subGenre" &&
                error[key] === "" &&
                key !== "isExplicit" &&
                key !== "thumbnailImg"
                  ? `${capitalize(getWords(t(`errorPopup.${key}`)))} ${t(
                      "errorPopup.error1"
                    )}`
                  : key === "isExplicit" && errors[key] === ""
                  ? t("errorPopup.error13")
                  : (key === "thumbnailImg" &&
                      typeof errors[key] !== "object") ||
                    (key === "thumbnailImg" &&
                      checkImgExtension(errors[key]["type"]) === false)
                  ? t("errorPopup.error11")
                  : (key === "audioFile" && typeof errors[key] !== "object") ||
                    (key === "audioFile" &&
                      (errors[key]["type"] === "video/webm" ||
                        errors[key]["type"] === "video/mp4"))
                  ? t("errorPopup.error14")
                  : ""}
              </DialogContentText>
            ))}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            sx={{ maxWidth: "150px", padding: "10px 35px" }}
            color="secondary"
            onClick={() => handleClose()}
          >
            {t("errorPopup.button")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
